export default {
    heading: {
        label: 'Название расписания',
        placeholder: 'Введите название расписания.. Вы можете использовать имя ответственного за него.',
        tool_tip_message: 'Введите название расписания.. Вы можете использовать имя ответственного за него.',
    },
    from_date: {
        label: 'Дата начала',
        placeholder: 'Выберите дату',
        tool_tip_message: 'Дата начала расписания',
    },
    to_date: {
        label: 'Дата окончания',
        placeholder: 'Выберите дату',
        tool_tip_message: 'Дата окончания расписания',
    },
    max_days: {
        label: 'Разрешить бронирование за',
        placeholder: 'Введите число',
        tool_tip_message: 'Максимальное количество дней, на которое пользователи могут резерв слоты заранее.',
    },
}
